import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { InfiniteScrollDirective } from '@df/module-infinite-scroll/infinite-scroll.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { PartitionPipe } from '@df/ui/common/partition.pipe';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { OrdinalPipe } from '@df/ui/display/ordinal.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content';
import { FilterPrimaryTagComponent } from '../../../../catalog/ui/listing/filter/primary-tag/filter-primary-tag.component';
import { ActionComponent } from '../../../../ui/api/action.component';
import { CmsBlogComponentListingAbstract } from './cms-blog-component-listing.abstract';
import { CMS_BLOG_COMPONENT_LISTING_CONFIG } from './cms-blog-component-listing.config';

@Component({
    selector: 'cms-blog-component-listing',
    templateUrl: './cms-blog-component-listing.component.html',
    standalone: true,
    imports: [
        ActionComponent,
        CommonModule,
        DfImageDirective,
        DragScrollDirective,
        FilterPrimaryTagComponent,
        GridModule,
        HrefComponent,
        ICmsClientModule,
        InfiniteScrollDirective,
        OrdinalPipe,
        PartitionPipe,
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsBlogComponentListingComponent>(CMS_BLOG_COMPONENT_LISTING_CONFIG)
export class CmsBlogComponentListingComponent extends CmsBlogComponentListingAbstract {}
